export const fetchAllPaginatedOptions = async (GetPaginatedData, api) => {
  const firstPage = await GetPaginatedData(api, { page: 1, search: "" });
  const items = [...(firstPage?.data || [])];
  let nextPage = firstPage?.nextPage;

  for (let page = 2; nextPage; page += 1) {
    const response = await GetPaginatedData(api, { page, search: "" });
    const nextItems = response?.data || [];
    if (nextItems.length === 0) break;
    items.push(...nextItems);
    nextPage = response?.nextPage;
  }

  return items;
};

export const getBulkResultMessage = (response, label) => {
  const result = response?.data || {};
  const created = result.total_created ?? result.created?.length ?? 0;
  const skipped = result.total_skipped ?? result.skipped?.length ?? 0;

  if (created && skipped) return `${created} ${label} added; ${skipped} already existed.`;
  if (created) return `${created} ${label} added successfully.`;
  if (skipped) return `All ${label} are already added.`;
  return `${label} updated successfully.`;
};
